/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import Link from '~hooks/link';
import useIsMobile from '~hooks/useIsMobile';
import ConditionalWrapper from '~atoms/conditional-wrapper';
import { imagePrettyUrl } from '~helpers/getters';
import { NavigationContext } from '~organisms/navigation/navigationContext';

import styles from './item.module.scss';

export default function Item({
  item,
  hasChildren,
  showSubMenuHandler,
  options = {
    mobile: {
      subMenuDropDownButton: true,
    },
  },
  gtmClass = '',
}) {
  const [active, setActive] = useState('');
  const [opened, setOpened] = useState(false);

  const { setShowMenu } = useContext(NavigationContext);

  useEffect(() => {
    const url = typeof window !== 'undefined' ? new URL(window.location.href) : '';
    setActive(
      url.pathname === item.value || url.pathname.substr(1) === item.value ? styles.active : ''
    );
  }, [active, item]);

  const handleClose = () => {
    setShowMenu(false);
  };

  const toggleDropDown = (e) => {
    e.target.classList.toggle(styles.active);
    setOpened(e.target.classList.contains(styles.active));
  };
  const isMobile = useIsMobile();

  const ItemImage = () =>
    item.image ? (
      <img width="20" height="20" src={imagePrettyUrl(item.image)} alt={item.title} />
    ) : null;

  return (
    <ConditionalWrapper
      condition={hasChildren}
      wrapper={(items) => (
        <div
          className={`${styles.itemWrapper} ${item.image && styles.itemWrapperIcon} ${
            options.mobile.subMenuDropDownButton && isMobile ? styles.dropDownButton : ''
          }`}
          onTouchStart={!options.mobile.subMenuDropDownButton ? showSubMenuHandler : null}
        >
          {items}
        </div>
      )}
    >
      {item.value?.includes('http') || item.value?.includes('www') ? (
        <a
          aria-label={`${item?.title} link`}
          href={item.value ? item.value : '#'}
          title={item.title}
          rel={`noreferrer ${item.nofollow && 'nofollow'}`}
          target="_blank"
          className={`${gtmClass} ${styles.item} ${opened && styles.openedLink} ${active} ${
            !options.mobile.subMenuDropDownButton && isMobile && hasChildren
              ? styles.inactiveLink
              : ''
          } ${hasChildren ? styles.hasChildren : ''} ${
            !options.mobile.subMenuDropDownButton ? styles.noDropDownButton : ''
          }`}
        >
          <ItemImage />
          {item.title}
        </a>
      ) : item.value !== null ? (
        <Link
          className={`${gtmClass} ${styles.item} ${opened && styles.openedLink} ${active} ${
            !options.mobile.subMenuDropDownButton && isMobile && hasChildren
              ? styles.inactiveLink
              : ''
          } ${hasChildren ? styles.hasChildren : ''} ${
            !options.mobile.subMenuDropDownButton ? styles.noDropDownButton : ''
          }`}
          disabled={item.value === null}
          to={item.value}
          title={item.title}
          rel={item.nofollow && 'nofollow'}
          aria-label={`${item?.title} link`}
          onClick={handleClose}
        >
          <ItemImage />
          {item.title}
        </Link>
      ) : (
        <div className={`${styles.item} ${opened && styles.openedLink}`}>{item.title}</div>
      )}
      {options.mobile.subMenuDropDownButton && hasChildren && (
        <button
          aria-label={`${item?.title} Dropdown`}
          type="button"
          className={`${gtmClass} btn-cta`}
          onClick={(e) => {
            showSubMenuHandler(styles);
            toggleDropDown(e);
          }}
        >
          {' '}
        </button>
      )}
    </ConditionalWrapper>
  );
}

Item.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    value: PropTypes.string,
    nofollow: PropTypes.bool,
    image: PropTypes.string,
    children: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        value: PropTypes.string,
      })
    ),
  }).isRequired,
  hasChildren: PropTypes.bool,
  showSubMenuHandler: PropTypes.func,
  options: PropTypes.shape({
    mobile: PropTypes.shape({
      subMenuDropDownButton: PropTypes.bool,
    }),
  }),
  gtmClass: PropTypes.string,
};
